import { SiteIdOverrideConfig } from "stores/wizard/config";

export const siteId1: SiteIdOverrideConfig = {
  global: {
    heroImageSrc: "https://a.travel-assets.com/travel-assets-manager/cmct-2428/US_Winter_1400x600.jpg",
    includeSingleLOBsWithinPackages: true,
  },
  car: {
    date: {
      maxDaysRange: 329,
    },
    timeFormats: {
      timeFormat12Hour: true,
    },
    AARPCheckbox: true,
  },
  cruise: {
    heading: {
      lobSubtitleBreakPoint: "on",
      visibleLobSubtitle: true,
      locSubtitleVariant: "1-800-916-8586",
    },
  },
  lx: {
    heading: {
      visibleLobSubtitle: true,
      locSubtitleLinkUrl: "https://www.expedia.com/event-tickets/",
    },
  },
};
